import { Grid, Tab, Tabs, Typography } from '@material-ui/core';
import { FuncaoParticipante, Perfil } from 'common/genericTypes';
import { HorizontalAppBar } from 'components/horizontalAppBar';
import { Button, LgSpace, MdSpace, SmSpace } from 'm2m.components';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState } from 'store';
import ListaConciliacoes from './listaConciliacoes';
import ListaConstricoesGarantias from './listaConstricoesGarantias';
import ListaContasDeposito from './listaContasDeposito';
import ListaInvestidores from './listaInvestidores';

const GerenciarInvestidores: React.FC = () => {
  const [tabValue, setTabValue] = useState<number>(0);

  const isParticipanteCustodiante =
    useSelector((state: RootState) => state.auth.usuario.participante.funcao) === FuncaoParticipante.Custodiante;
  const isUsuarioLeitura = useSelector((state: RootState) => state.auth.usuario.participante.perfil === Perfil.Leitura);

  const history = useHistory();

  return (
    <div style={{ margin: '0 40px 80px 0' }}>
      <Grid container justify="space-between" alignItems="center">
        <Grid item>
          <Typography variant="h1">{'Investidores'}</Typography>
        </Grid>

        {isParticipanteCustodiante && !isUsuarioLeitura && (
          <div style={{ display: 'grid' }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => history.push('/gerenciar/investidores/cadastro')}
              data-testId="btnNovoInvestidor"
            >
              {'Novo Investidor'}
            </Button>

            <SmSpace />

            <Button
              variant="contained"
              color="primary"
              onClick={() => history.push('/upload_arquivos?tab=1&tipo=CadastroEmLote')}
            >
              {'Cadastrar Investidores em Lote'}
            </Button>
          </div>
        )}
      </Grid>
      <LgSpace />
      <HorizontalAppBar>
        <Tabs indicatorColor="primary" value={tabValue} onChange={(_event, newTab) => setTabValue(newTab)}>
          <Tab label="Investidores" value={0} />
          <Tab label="Contas Depósito" value={1} />
          <Tab label="Constrições e Garantias" value={2} />
          {isParticipanteCustodiante && <Tab label="Conciliações" value={3} />}
        </Tabs>
      </HorizontalAppBar>
      <MdSpace />
      {tabValue === 0 && <ListaInvestidores />}
      {tabValue === 1 && <ListaContasDeposito />}
      {tabValue === 2 && <ListaConstricoesGarantias />}
      {tabValue === 3 && <ListaConciliacoes />}
    </div>
  );
};

export default GerenciarInvestidores;
